<template src="../templates/normal_fcont_130.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import CreativePrintInText from '../components/CreativePrintInText'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import CreatorProfileItsuka from "../components/CreatorProfileItsuka";
import InfoMachineTranslation from '../components/InfoMachineTranslation'
import AppDownloadCreative from '../components/AppDownloadCreative'
import PrintButton from '../components/PrintButton'
import AppDownloadPhotoPlus from '../components/AppDownloadPhotoPlus'
import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,FuncSearchGalleryQR,CreativePrintInText,
    CreatorProfileItsuka,InfoMachineTranslation,AppDownloadCreative,PrintButton,AppDownloadPhotoPlus
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  computed: {
  },
  methods: {
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['130-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['130-2']}
    ]};
  }
  
};
</script>
<style >
</style>

